import {store} from "../../../Store/index.js";
import {O} from "web-vcore";
import {CameraConfig} from "./@CameraConfig.js";
import {ignore} from "mobx-sync";

export enum MonitorTab {
	//Dashboard = 10,
	//General = 20,
	Camera = "Camera",
	Muse = "Muse",
	Belt = "Belt",
	LD1 = "LD1",
	LD1Config = "LD1Config",
	LD1Settings = "LD1Settings",
}
export enum MuseSubtab {
	EEG = 10,
	Gyro = 20,
	Others = 30,
}

export class MonitorState {
	@O accessor tab = MonitorTab.Camera;

	// camera
	// ==========

	@O accessor cameraConfig = new CameraConfig();
	@O @ignore accessor preview = false;
	@O accessor overlay_ignoreRects = true;
	//@O overlay_pixelPercentToTrigger = true;
	@O accessor overlay_pixelTriggers = false; // disabled by default, since heavy on cpu
	@O accessor graph_triggerPixelCount = true;
	@O accessor cam_showAdvanced = false;

	@O @ignore accessor record = false;
	@ignore accessor recorder: any;
	@ignore accessor recordedChunks: BlobPart[] = [];

	// muse
	// ==========

	@O accessor muse_subtab = MuseSubtab.EEG;

	// eeg
	@O @ignore accessor eeg_monitor = false;
	@O @ignore accessor eeg_generateFake = false;
	//@O @ignore museStatus = "disconnected" as MuseConnectStatus; // (moved to MuseInterface.ts)
	//@O eeg_showRaw = false;
	//@O eeg_showNormalized = true;
	@O accessor eeg_normalize = true;
	@O accessor eeg_smooth = true;
	/*@O eeg_show_combinedDeviation = false;
	@O accessor eeg_show_triggerSamplePercent = false;*/
	//@O eeg_range = 100;
	@O @ignore accessor eegProcessor_changedAt = 0;

	// gyro
	@O @ignore accessor gyro_monitor = false;
	@O @ignore accessor gyro_generateFake = false;
	@O accessor gyro_normalize = true;
	@O accessor gyro_smooth = true;
	/*@O gyro_show_combinedDeviation = false;
	@O accessor gyro_show_triggerSamplePercent = false;*/
	@O @ignore accessor gyroProcessor_changedAt = 0;

	// others
	@O accessor muse_freezeDetectTime = 10;

	// belt
	// ==========

	@O @ignore accessor belt_monitor = false;

	@O accessor autoConnect_beltDevices = [] as {id: string, enabled: boolean}[];

	// ld1
	// ==========

	@O accessor ld1 = new LD1State();
}

export class LD1State {
	@O accessor commandsAutoRun = true;
	@O @ignore accessor consoleLines = [] as string[];

	@O accessor motor_pin = 2;
	@O @ignore accessor motor_power = 0; // 0-255
	@O accessor motor_period = 65;

	// from config panel
	@O accessor magRangeCollecting_expandOnly = false;
	@O accessor config1 = new LD1Config();

	// from settings panel
	@O accessor deviceAddresses = [
		//"00:11:22:33:44:55",
		"E9:60:3B:58:24:03", // Nano 33 BLE, with headers (#1)
		"E0:56:D8:DB:C7:F1", // Nano 33 BLE, without headers
		"49:92:DB:6F:E0:40", // Nano 33 BLE, with headers (#2)
	];
	@O accessor deviceAddresses_activeIndex = 1;
}

export function GetMonitorCameraConfig() {
	return store.main.tools.monitor.cameraConfig;
}

// NOTE: All fields must start with a default value, so that `Object.keys(new LD1Config())` can enumerate the field-names. (eg. for SendLD1ConfigToDevice)
export class LD1Config {
	// todo: populate these with workable defaults
	@O accessor magRanges_xMin = 0;
	@O accessor magRanges_xMax = 0;
	@O accessor magRanges_yMin = 0;
	@O accessor magRanges_yMax = 0;
	@O accessor magRanges_zMin = 0;
	@O accessor magRanges_zMax = 0;

	// Note: These values are for the "raw magnetometer values", ie. prior to usage/calculation of true/geographic north (ie. using declination), and prior to custom offset.
	// todo: maybe rename this term from "magnetometer value" to "magnetometer angle" (to distinguish it more clearly from the raw readings)
	@O accessor magValForNorth = 0;
	@O accessor magValForEast = 90;
	@O accessor magValForSouth = 180;
	@O accessor magValForWest = 270;
	@O accessor additionalMagTargetOffset = 0;

	@O accessor motorPin_front = 8;
	@O accessor motorPin_right = 2;
	@O accessor motorPin_back = 4;
	@O accessor motorPin_left = 6;

	@O accessor vibrateMultiplier_front = 1;
	@O accessor vibrateMultiplier_right = 1;
	@O accessor vibrateMultiplier_back = 1;
	@O accessor vibrateMultiplier_left = 1;

	@O accessor logSensorReadings = false;
	@O accessor logDirection = true;
	@O accessor vibrateStrength = .5; // 0-1
	@O accessor minTurnAmountForVibrate = 70;
	@O accessor maxAngleFromVerticalForVibrate = 20;
	@O accessor minTimeSinceBadAngleForVibrate = 1000;
	@O accessor averageHeadingOverXMilliseconds = 0;
	@O accessor useBoardLights = true;
}